module.exports = __webpack_public_path__ + "img/portada.ec735c76.jpg";